import React from 'react';
import { loadStripe } from '@stripe/stripe-js';
import { Elements, CardElement, useStripe, useElements } from '@stripe/react-stripe-js';

const StripeCheckout = props => {
  const {
    publicKey
  } = props;

  if (!publicKey) {
    return null;
  }

  const stripePromise = loadStripe(publicKey);

  const handleClick = async () => {
    const stripe = await stripePromise;
    const elements = stripe.elements();
    const cardElement = elements.create('card');
    cardElement.mount('#card-element');

    cardElement.on('change', event => {
      if (event.error) {
        console.error(event.error.message);
      }
    });

    const { error, paymentMethod } = await stripe.createPaymentMethod({
      type: 'card',
      card: cardElement,
    });

    if (error) {
      console.error(error);
    } else {
      console.log(paymentMethod);
    }
  };

  return (
    <>
      <div id="card-element"></div>
      <button onClick={handleClick}>Checkout</button>
    </>
  )
}

export default StripeCheckout;
